import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@eng-ds/translate';
import { NbButtonModule } from '@nebular/theme';
import { StandaloneActionsToolbarComponent } from './standalone-actions-toolbar.component';

@NgModule({
    imports: [CommonModule, NbButtonModule, TranslateModule.forChild(), StandaloneActionsToolbarComponent],
    exports: [StandaloneActionsToolbarComponent]
})
export class StandaloneActionsToolbarModule {}
